import { StyleSheet } from "react-native";
import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useEffect } from "react";
import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import InstanceIndex from "../../components/UI/AddingData/InstanceIndex";
import { CustomBtn } from "../Users/CreateUserScreen";
import RequestModal from "../../components/utils/RequestModal";

const CourseDetailsScreen = () => {
  const [currentPackage, setCurrentPackage] = useState(false);
  const courses = useSelector((state) => state.courses.requestedCourses);
  const [requestModal, setRequestModal] = useState(false)
  const id = useParams().id;
  const history = useHistory();

  const setUp = () => {
    let objData = {};
    let check = courses.find((a) => a._id == id);
    if (check) {
      objData = { ...check };
    }

    setCurrentPackage(objData);
  };

  useEffect(() => {
    setUp();
  }, []);

  const sendRequest = () => {
    setRequestModal(!requestModal)
  }

  return (
    <div className='flex flex-col items-center w-full '>
      {requestModal && <RequestModal data={currentPackage} requestType={1} toggleModal={sendRequest} />}

      <HeaderContainer label={t("course")} />
      {currentPackage && (
        <Container
          currentPackage={currentPackage}
        />
      )}
      <CustomBtn
        label={"sendRequest"}
        onClick={sendRequest}
        bgColor="bg-blue-400"
      />
    </div>
  );
};

const Container = ({ onChangeValue, admins, currentPackage, centers }) => {
  return (
    <div className='w-4/5 mt-10 border max-h-max'>
      <InputContainer
        onChangeValue={onChangeValue}
        currentPackage={currentPackage}
        centers={centers}
        admins={admins}
      />
    </div>
  );
};

const InputContainer = ({ onChangeValue, currentPackage, centers }) => {
  const { t } = useTranslation();
  const admins = useSelector(state => state.admins.admins)
  return (
    <div className='items-center justify-center bg-white'>
      {currentPackage._id && (
        <InstanceIndex label={t("id")} value={`#${currentPackage._id}`} />
      )}
      <InstanceIndex label={t("name")} value={`${admins.find(a => a._id === currentPackage.trainerId)?.name}`} />
      <InstanceIndex label={t("price")} value={`${currentPackage.price}$ - ${currentPackage.iqd} IQD`} />
    </div>
  );
};

export default CourseDetailsScreen;

const styles = StyleSheet.create({});
